import { render, staticRenderFns } from "./MothersDay_defaultSection.vue?vue&type=template&id=6f470c52&scoped=true"
import script from "./MothersDay_defaultSection.vue?vue&type=script&lang=ts"
export * from "./MothersDay_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./MothersDay_defaultSection.vue?vue&type=style&index=0&id=6f470c52&prod&lang=css"
import style1 from "./MothersDay_defaultSection.vue?vue&type=style&index=1&id=6f470c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f470c52",
  null
  
)

export default component.exports